import { MODE } from './amplify/config'

const storeLink = MODE === 'qa' ? 'https://website.waterguru-qa.com' : 'https://waterguru.com'

export {
    storeLink
}
